// package mind.yushu.com.mindmap.viewmodel.datatype;

// import com.google.gson.annotations.SerializedName;

/**
 * Created by tony on 2019/12/27
 */

let IconLayoutType = {
    LAYOUT_RIGHT:1,
    LAYOUT_LEFT:2,
    LAYOUT_TOP:3,
    from:function(value) {
        for(let mealName of Object.values(this)){
            if(mealName == value){
                return value;
            }
        }
        return this.LAYOUT_RIGHT;
    }

}
export default IconLayoutType
